export const routes = (prefix = `profile`) => [
    {
        path: `/${prefix}/appointments`,
        name: `${prefix}.appointments.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.appointments.index`,
                PageDescription: "Consultant: My Appointments",
            },
        },
    },
];
